'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestStartedWithOperator = undefined;

var _asyncStatuses = require('../constants/asyncStatuses');

var _requestStateUpdate = require('./requestStateUpdate');

/**
 * Set status and operate on data when a request started
 *
 * @param {Function} operator operator to apply to data
 * @param {AsyncData} asyncData AsyncData record to update
 * @returns {AsyncData}
 */
var requestStartedWithOperator = exports.requestStartedWithOperator = (0, _requestStateUpdate.requestStateUpdate)(_asyncStatuses.STARTED);